import { render, staticRenderFns } from "./ViewOrganizationPage.vue?vue&type=template&id=946fc748"
import script from "./ViewOrganizationPage.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports